<template>
  <div class="page">
    <main>
      <!-- Hero Section -->
      <section class="hero">
        <div class="container">
          <h1 class="title">
            视频翻译多国语言<br />字幕和旁白一键处理
          </h1>
          <p class="subtitle">
            KisiAI 自研语音克隆方案实现高还原度，同时让您的声音更加动听
          </p>
              <div class="heroImage">
                <video autoplay loop playsinline>
                  <source src="https://video.kisiai.com/videos/translate.mp4" type="video/mp4">
                  您的浏览器不支持视频播放
                </video>
              </div>
              <button class="uploadButton" @click="handleStart">立即体验</button>
        </div>
      </section>

      <!-- Features Section -->
      <section class="features">
        <div class="container">
          <div class="featureMain">
            <div class="featureContent">
              <h2>自动提高定向营销口播视频翻译</h2>
              <p>
                AI 大语言模型(LLM)支持的精准内容翻译，自动识别视频语音内容，快速生成多语言字幕和配音。
                支持 40+ 种主流语言，借助精准的 AI 翻译和配音技术，让您的视频轻松覆盖全球观众，快速提升品牌知名度和市场渗透力。让您的视频内容快速触达全球用户。
              </p>
              <button class="primaryButton" @click="handleStart">立即体验</button>
            </div>
            <div class="featureDemo">
              <video 
                class="demoVideo"
                controls
              >
                <source src="https://video.kisiai.com/videos/sample-2x.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>

      <!-- Benefits Section -->
      <section class="benefits">
        <div class="container">
          <div class="benefitCards">
            <div class="benefitCard">
              <h3>扩大多国市场影响力</h3>
              <p>覆盖40+主流语言，快速进入全球市场，提升品牌国际影响力。借助精准的 AI 翻译和配音技术，让您的视频轻松覆盖全球观众，快速提升品牌知名度和市场渗透力。</p>
            </div>
            <div class="benefitCard">
              <h3>低成本拟补本土主播</h3>
              <p>无需重新拍摄，「视频翻译」结合「视频换脸」功能，帮助您轻松创建针对不同市场的定制化营销视频，高效传递品牌信息，节省成本。</p>
            </div>
            <div class="benefitCard">
              <h3>原音色 AI 配音合成</h3>
              <p>原音色 AI 配音技术，完美克隆原声情感和音调，为视频生成自然流畅的多语言配音，真正实现全球传播的专业水准。</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Process Section -->
      <section class="process">
        <div class="container">
          <h2>如何快速完成视频翻译？</h2>
          <div class="steps">
            <div class="step">
              <div class="stepNumber">Step 1</div>
              <h3>上传你的营销视频</h3>
              <p>支持多种格式视频文件，快速上传处理</p>
              <div class="stepImage">
                <img 
                  :src="require('@/assets/images/steps/step1.png')" 
                  alt="上传视频" 
                  width="320" 
                  height="180" 
                />
              </div>
            </div>
            <div class="step">
              <div class="stepNumber">Step 2</div>
              <h3>选择翻译目标语言</h3>
              <p>支持40+种语言互译，覆盖主流市场</p>
              <div class="stepImage">
                <img 
                  :src="require('@/assets/images/steps/image.png')" 
                  alt="选择语言" 
                  width="320" 
                  height="180" 
                />
              </div>
            </div>
            <div class="step">
              <div class="stepNumber">Step 3</div>
              <h3>生成翻译视频</h3>
              <p>自动生成字幕和配音，一键导出成片</p>
              <div class="stepImage">
                <img 
                  :src="require('@/assets/images/steps/step3.png')" 
                  alt="生成视频" 
                  width="320" 
                  height="180" 
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { handleStart } from '@/utils/navigation'

export default {
  name: 'VideoTranslation',
  methods: {
    handleStart() {
      handleStart(this.$router, this.$store)
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.hero {
  padding: 120px 0 80px;
  background: linear-gradient(180deg, #F9FAFB 0%, rgba(249, 250, 251, 0) 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.tag {
  display: inline-block;
  padding: 6px 12px;
  background: rgba(99, 102, 241, 0.1);
  color: #6366F1;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 24px;
}

.title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
  margin-bottom: 24px;
}

.subtitle {
  font-size: 18px;
  color: #6B7280;
  max-width: 600px;
  margin: 0 auto 40px;
}

.uploadArea {
  max-width: 480px;
  margin: 0 auto;
}

.uploadBox {
  background: white;
  border: 2px dashed #E5E7EB;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  transition: all 0.2s;
}

.uploadBox:hover {
  border-color: #6366F1;
}

.upload-preview {
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-bottom: 20px;
  object-fit: cover;
}

.uploadButton {
  padding: 14px 32px;
  background: #6366F1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.uploadButton:hover {
  background: #4F46E5;
  transform: translateY(-1px);
}

.worldMap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -30%);
  width: 100%;
  max-width: 1400px;
  z-index: -1;
}

/* Features Section */
.features {
  padding: 120px 0;
}

.featureMain {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}

.featureContent h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 24px;
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.featureContent p {
  font-size: 18px;
  color: #6B7280;
  margin-bottom: 32px;
  line-height: 1.6;
}

.featureDemo {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.demoVideo {
  width: 100%;
  display: block;
}

/* Benefits Section */
.benefits {
  padding: 80px 0;
}

.benefitCards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.benefitCard {
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.benefitCard h3 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #111827;
}

.benefitCard p {
  color: #6B7280;
  margin-bottom: 24px;
  line-height: 1.6;
}

/* Process Section */
.process {
  padding: 120px 0;
  text-align: center;
}

.process h2 {
  font-size: 36px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 64px;
}

.steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px;
}

.step {
  text-align: left;
}

.stepNumber {
  display: inline-block;
  padding: 6px 12px;
  background: rgba(99, 102, 241, 0.1);
  color: #6366F1;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 16px;
}

.step h3 {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}

.step p {
  color: #6B7280;
  margin-bottom: 24px;
}

.stepImage {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.stepImage img {
  width: 100%;
  height: auto;
  display: block;
}

.primaryButton {
  padding: 14px 32px;
  background: #6366F1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.primaryButton:hover {
  background: #4F46E5;
  transform: translateY(-1px);
}


.heroImage {
  margin-top: 48px;
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 16px;
  overflow: hidden;
}

.heroImage video {
  width: 100%;
  height: auto;
  border-radius: 16px;
  object-fit: cover;
}

@media (max-width: 768px) {
  .title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 16px;
  }

  .featureMain {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .benefitCards {
    grid-template-columns: 1fr;
  }

  .steps {
    grid-template-columns: 1fr;
  }

  .process h2 {
    font-size: 28px;
  }

  .uploadBox {
    padding: 16px;
  }
  
  .upload-preview {
    margin-bottom: 16px;
  }
  
  .uploadButton {
    padding: 12px 24px;
    font-size: 15px;
  }
}
</style> 